// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------------- WRAPPER ---------------- */
.identity-form-wrapper {
  padding: 20px;
  display: flex;
  justify-content: flex-start;
}

/* ---------------- CARD ---------------- */
.aptsi-card {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* ---------------- HEADER ---------------- */
h2 {
  margin-bottom: 20px;
  font-weight: 600;
}

/* ---------------- FORM ---------------- */
.form-control,
.form-select {
  height: 42px;
  border-radius: 4px;
}

.form-control:focus,
.form-select:focus {
  box-shadow: none;
  border: 1px solid #0060d6;
}

/* ---------------- LABEL ---------------- */
label {
  font-weight: 500;
  margin-bottom: 5px;
}

/* ---------------- KEY MODE SECTION ---------------- */
.key-mode-section {
  border: 1px solid #e2e6ea;
  border-radius: 6px;
  padding: 12px 15px;
  background-color: #fafafa;
}

.key-mode-section .form-label {
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.key-mode-options {
  display: flex;
  gap: 20px;
}

.key-mode-option {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.key-mode-option:hover {
  background-color: #f0f4ff;
}

.key-mode-option input[type=radio] {
  accent-color: #0060d6;
  cursor: pointer;
}

.key-mode-option.active {
  background-color: #e6f0ff;
  border: 1px solid #0060d6;
}

/* ---------------- BUTTONS ---------------- */
.action-buttons {
  margin-top: 15px;
}

.btn-submit {
  background-color: #0060d6;
  color: #fff;
  margin-right: 10px;
  transition: background 0.2s ease-in-out;
}

.btn-submit:hover {
  background-color: #1a1a86;
}

.btn-submit:disabled {
  background-color: #9aa7b3;
}

.btn-dark {
  transition: background 0.2s ease-in-out;
}

.btn-dark:hover {
  background-color: #222;
}

/* ---------------- LOADER ---------------- */
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader-box {
  background: #fff;
  padding: 20px 30px;
  border-radius: 10px;
  text-align: center;
}

/* ---------------- OPTIONAL CLEANUPS ---------------- */
.option {
  border: 1.5px solid rgba(222, 219, 219, 0.87);
  border-radius: 4px;
}

.option:hover {
  background-color: #f5f7fa;
}`, "",{"version":3,"sources":["webpack://./src/app/features/secure-blockchain/authoring-tools/smart-contract-operation/smart-contract-operation-submit/smart-contract-operation-submit.component.scss"],"names":[],"mappings":"AAAA,8CAAA;AAEA;EACE,aAAA;EACA,aAAA;EACA,2BAAA;AAAF;;AAGA,2CAAA;AAEA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,yCAAA;AADF;;AAIA,6CAAA;AAEA;EACE,mBAAA;EACA,gBAAA;AAFF;;AAKA,2CAAA;AAEA;;EAEE,YAAA;EACA,kBAAA;AAHF;;AAMA;;EAEE,gBAAA;EACA,yBAAA;AAHF;;AAMA,4CAAA;AAEA;EACE,gBAAA;EACA,kBAAA;AAJF;;AAOA,uDAAA;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AALF;;AAQA;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;AALF;;AAQA;EACE,aAAA;EACA,SAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,qBAAA;EACA,eAAA;AALF;;AAQA;EACE,yBAAA;EACA,yBAAA;AALF;;AAQA,8CAAA;AAEA;EACE,gBAAA;AANF;;AASA;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;AANF;;AASA;EACE,yBAAA;AANF;;AASA;EACE,yBAAA;AANF;;AASA;EACE,uCAAA;AANF;;AASA;EACE,sBAAA;AANF;;AASA,6CAAA;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAPF;;AAUA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAPF;;AAUA,wDAAA;AAEA;EACE,6CAAA;EACA,kBAAA;AARF;;AAWA;EACE,yBAAA;AARF","sourcesContent":["/* ---------------- WRAPPER ---------------- */\n\n.identity-form-wrapper {\n  padding: 20px;\n  display: flex;\n  justify-content: flex-start;\n}\n\n/* ---------------- CARD ---------------- */\n\n.aptsi-card {\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 25px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n/* ---------------- HEADER ---------------- */\n\nh2 {\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n\n/* ---------------- FORM ---------------- */\n\n.form-control,\n.form-select {\n  height: 42px;\n  border-radius: 4px;\n}\n\n.form-control:focus,\n.form-select:focus {\n  box-shadow: none;\n  border: 1px solid #0060d6;\n}\n\n/* ---------------- LABEL ---------------- */\n\nlabel {\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n\n/* ---------------- KEY MODE SECTION ---------------- */\n\n.key-mode-section {\n  border: 1px solid #e2e6ea;\n  border-radius: 6px;\n  padding: 12px 15px;\n  background-color: #fafafa;\n}\n\n.key-mode-section .form-label {\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.key-mode-options {\n  display: flex;\n  gap: 20px;\n}\n\n.key-mode-option {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.key-mode-option:hover {\n  background-color: #f0f4ff;\n}\n\n.key-mode-option input[type=\"radio\"] {\n  accent-color: #0060d6;\n  cursor: pointer;\n}\n\n.key-mode-option.active {\n  background-color: #e6f0ff;\n  border: 1px solid #0060d6;\n}\n\n/* ---------------- BUTTONS ---------------- */\n\n.action-buttons {\n  margin-top: 15px;\n}\n\n.btn-submit {\n  background-color: #0060d6;\n  color: #fff;\n  margin-right: 10px;\n  transition: background 0.2s ease-in-out;\n}\n\n.btn-submit:hover {\n  background-color: #1a1a86;\n}\n\n.btn-submit:disabled {\n  background-color: #9aa7b3;\n}\n\n.btn-dark {\n  transition: background 0.2s ease-in-out;\n}\n\n.btn-dark:hover {\n  background-color: #222;\n}\n\n/* ---------------- LOADER ---------------- */\n\n.loader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.loader-box {\n  background: #fff;\n  padding: 20px 30px;\n  border-radius: 10px;\n  text-align: center;\n}\n\n/* ---------------- OPTIONAL CLEANUPS ---------------- */\n\n.option {\n  border: 1.5px solid rgba(222, 219, 219, 0.87);\n  border-radius: 4px;\n}\n\n.option:hover {\n  background-color: #f5f7fa;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
